import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {CookieService} from 'ngx-cookie-service';
import {AffiliateService} from '@services/affiliate.service';

@Component({
    selector: 'app-affiliation',
    templateUrl: './affiliation.component.html',
    styleUrls: ['./affiliation.component.scss']
})
export class AffiliationComponent implements OnInit {

    params;

    constructor(
        public authenticationService: AuthenticationService,
        private router: Router,
        private cookieService: CookieService,
        private affiliateService: AffiliateService,
        private route: ActivatedRoute) {

    }

    ngOnInit(): void {

        if (this.authenticationService.isLogin) {
            this.router.navigate(['/app']);
        }

        this.route.params.subscribe(params => {
            this.params = params;
            if (params.affiliate !== undefined) {
                // Valide le code côté serveur avant de poser le cookie, puis redirige.
                this.affiliateService.resolve(params.affiliate).subscribe(() => {
                    this.cookieService.set('affiliate-code', params.affiliate, 7, "/");
                    this.router.navigate(['/app/register']);
                }, () => {
                    this.router.navigate(['/app/register']);
                });
            }
        });
    }

}
